// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"MenuBlock_menuBlock__1MOlY","menuItemList":"MenuBlock_menuItemList__2w6U4"};